import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const PencilSignIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g fill="#222" clipPath="url(#clip0_16381_2961)">
            <path d="M18.7428 6.8397L19.729 7.05456L17.613 16.7662L17.0125 17.1519L16.6269 16.5514L18.7428 6.8397ZM18.5691 1.40113C18.406 1.50593 18.2782 1.68019 18.2338 1.88386L17.8064 3.84548L21.8261 4.72129L22.2535 2.75967C22.3446 2.34161 22.0805 1.93039 21.6625 1.8393L19.1542 1.2928C18.9398 1.24609 18.7389 1.29214 18.5691 1.40113ZM17.5565 4.99245L14.9734 16.848L16.5454 19.2957L18.9932 17.7238L21.5762 5.86825L17.5565 4.99245Z" />
            <path
              d="M11.9741 13.2505C12.3373 13.2379 12.6572 13.4875 12.7334 13.8429L14.1063 20.25H19C19.4142 20.25 19.75 20.5858 19.75 21C19.75 21.4142 19.4142 21.75 19 21.75H13.5C13.1463 21.75 12.8407 21.503 12.7666 21.1572L12.1478 18.269L11.7425 21.1061C11.6897 21.4756 11.3732 21.75 11 21.75H8C7.71592 21.75 7.45622 21.5895 7.32918 21.3354L7 20.6771L6.67082 21.3354C6.54378 21.5895 6.28408 21.75 6 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21C2.25 20.5858 2.58579 20.25 3 20.25H5.53647L6.32918 18.6646C6.45622 18.4105 6.71592 18.25 7 18.25C7.28408 18.25 7.54378 18.4105 7.67082 18.6646L8.46353 20.25H10.3495L11.2575 13.8939C11.3089 13.5342 11.6109 13.263 11.9741 13.2505Z"
              fillRule="evenodd"
              clipRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_16381_2961">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
